var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-data-table',_vm._b({staticClass:"data-table_ap",attrs:{"headers":_vm.showedHeaders,"items":_vm.showedPoints,"item-class":"text-body-1","caption":_vm.points.objectName || 'Без привязки',"use-caption-as-index":false,"hide-default-footer":true},on:{"click:row":function (ref) {
    var number = ref.number;

      /*emitUpdateSliderPreloaderEvt(true);
      $emit('update:slider', true);

      chooseAccountingPoint(
        points.pointList.find((point) => point['номер'] === number)
      ).finally(() => {
        emitUpdateSliderPreloaderEvt(false);
      });*/
    }},scopedSlots:_vm._u([{key:"afterCaption",fn:function(){return [_c('table-dropdown',{attrs:{"items":_vm.dropdownItems,"column":_vm.columnStates},on:{"update:column":function($event){_vm.columnStates=$event},"on-activator":function($event){return _vm.$emit('update:wall', true)}}})]},proxy:true}])},'x-data-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }